<template>
	<div class="bookcityBox">
		<van-sticky>
			<!-- 一级导航 -->
			<firsttabbar @firstValue="firstValueTab" :swiperSendIndex="swiperToNav"></firsttabbar>
			<!-- height_scroll == 100 ? 'bgcwhite' : '' -->
			<secondCategroy  @firSecondCategroy="getFirCateValue" :firstCateSwiperSendIndex="secondCategroySwToNav" 
			v-if="swiperToNav == 0 && height_scroll < 7 ? true : false"></secondCategroy>

			<secondCategroy  class="bgcwhite" @firSecondCategroy="getFirCateValue"
			 :firstCateSwiperSendIndex="secondCategroySwToNav" v-if="swiperToNav == 0 && height_scroll >= 7 ? true : false"></secondCategroy>


			<secondwanjie @firSecondCategroy02="getFirCateValue02" :firstCateSwiperSendIndex02="secondCategroySwToNav02" v-if="swiperToNav == 1 ? true : false"></secondwanjie>
			<secondchunai @firSecondCategroy03="getFirCateValue03" :firstCateSwiperSendIndex03="secondCategroySwToNav03" v-if="swiperToNav == 2 ? true : false"></secondchunai>
			<secondyansheng @firSecondCategroy04="getFirCateValue04" :firstCateSwiperSendIndex04="secondCategroySwToNav04" v-if="swiperToNav == 3 ? true : false"></secondyansheng>
		</van-sticky>
		<div v-if="bookcityBox_show" class="bookcity_box">
			<!-- <van-pull-refresh v-model="isLoading" @refresh="onRefresh" loosing-text="正在获取"> -->
				<!-- 一级 -->
				<swiperfirstabar
				:swiperIndex="slideIndex" 
				@slideTab="slideSendNav" 
				v-if="secondCategroySldIdx != null 
				|| secondCategroySldIdx02 != null 
				|| secondCategroySldIdx03 != null
				|| secondCategroySldIdx04 != null 
				? false : true "></swiperfirstabar>
				<!-- 一级 -- 二级  -->
				<swipersecondcatetabar 
				:swiperIndexFirstSe="secondCategroySldIdx" 
				@firSecondCateSlideTab="firstCateSlideSendNav"
				v-if="secondCategroySldIdx != null && swiperToNav == 0? true : false "
				></swipersecondcatetabar>
				
				<!-- 言情 -- 二级 -->
				<swipersecondcatetabar02 
				:swiperIndexFirstSe02="secondCategroySldIdx02" 
				@firSecondCateSlideTab02="firstCateSlideSendNav02"
				v-if="secondCategroySldIdx02 != null && swiperToNav == 1 ? true : false "
				></swipersecondcatetabar02>
				
				<!-- 纯爱 -- 二级 -->
				<swipersecondcatetabar03 
				:swiperIndexFirstSe03="secondCategroySldIdx03" 
				@firSecondCateSlideTab03="firstCateSlideSendNav03"
				v-if="secondCategroySldIdx03 != null && swiperToNav == 2 ? true : false "
				></swipersecondcatetabar03>
				
				<!-- 衍生-- 二级 -->
				<swipersecondcatetabar04 
				:swiperIndexFirstSe04="secondCategroySldIdx04" 
				@firSecondCateSlideTab04="firstCateSlideSendNav04"
				v-if="secondCategroySldIdx04 != null && swiperToNav == 3 ? true : false "
				></swipersecondcatetabar04>
			<!-- </van-pull-refresh> -->
		</div>
		<div style="height: 1.5rem;"></div>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';
	// 导航组件
	import firsttabbar from '@/views/bookcity/firsttabbar.vue';
	import secondCategroy from '@/views/bookcity/secondCategroy.vue';
	import secondwanjie from '@/views/bookcity/secondwanjie.vue';
	import secondchunai from '@/views/bookcity/secondchunai.vue';
	import secondyansheng from '@/views/bookcity/secondyansheng.vue';
	//一级导航组件
	import swiperfirstabar from '@/views/bookcity/swiper_first_tab.vue';
	// 二级导航组件 -- 分类
	import swipersecondcatetabar from '@/views/bookcity/swiper_first_scend_tab01.vue';
	//二级导航组件 -- 言情
	import swipersecondcatetabar02 from '@/views/bookcity/swiper_first_scend_tab02.vue';
	//二级导航组件 -- 纯爱
	import swipersecondcatetabar03 from '@/views/bookcity/swiper_first_scend_tab03.vue';
	//二级导航组件 -- 衍生
	import swipersecondcatetabar04 from '@/views/bookcity/swiper_first_scend_tab04.vue';
	export default {
		components: {
			// 导航组件
			firsttabbar,
			secondwanjie,
			secondCategroy,
			secondchunai,
			secondyansheng,
			// 组件
			swiperfirstabar,
			swipersecondcatetabar,
			swipersecondcatetabar02,
			swipersecondcatetabar03,
			swipersecondcatetabar04,
		},
		data() {
			const that_tabVal = this;
			return {
				// homeListData: {
				// 	rotation_msg: [], //新闻轮播
				// 	banner_list: [], //banner轮播
				// 	yjjb_list: [], //云锦金榜
				// 	syqt_list: [], //首页强推
				// 	yqwjjp_list: [], //言情完结精品
				// 	yswjjp_list: [], //衍生完结精品
				// 	vxwzb_list: [], //VIP完结精品
				// 	new_list: [], //最近更新
				// 	label: [], //热门导航
				// 	dark_horse_list: [], //黑马榜
				// 	cawjjp_list: [], //纯爱完结精品
				// },
				// gettabArridx: '',
				height_scroll: 0,
				bookcityBox_show: false,
				isLoading: false,

				slideIndex: 0, // 点击导航发送给swiper的值
				swiperToNav: 0, // swiper滑动下标值传给nav导航

				secondCategroySldIdx: null, //二级点击
				secondCategroySwToNav: null, //二级滑动

				secondCategroySldIdx02: null, //二级点击 言情
				secondCategroySwToNav02: null, //二级滑动 言情
				
				secondCategroySldIdx03: null, //二级点击 纯爱
				secondCategroySwToNav03: null, //二级滑动 纯爱
				
				secondCategroySldIdx04: null, //二级点击 衍生
				secondCategroySwToNav04: null, //二级滑动 衍生
			}
		},
		created() {
			this.getFirstvaluetab = this.$route.query.getFirstvaluetab  ? this.$route.query.getFirstvaluetab : 0;
			this.getSecondtab = this.$route.query.getSecondtab  ? this.$route.query.getSecondtab : null;
			// this.gettabArridx = this.$route.query.gettabArridx != '' ? this.$route.query.gettabArridx : '';
			Toast.loading({
				message: '加载中...',
				forbidClick: true,
			});
			this.bookcityIndexDataFn();
		},
		watch: {
			// 监听导航传给swiper时候，把数据传给父亲时候传参值的变化
			slideIndex(value, oldvalue) {
				// swiper滑动下标值传给nav导航,目的是为了导航的下标和swiper的下标索引能时时同步不存在bug
				this.swiperToNav = value;
				this.slideIndex = value;
			},
			swiperToNav(value, oldValue) {
				// 点击导航发送给swiper的值,目的是为了导航的下标和swiper的下标索引能时时同步不存在bug
				this.slideIndex = value;
				this.swiperToNav = value;
			},
			// 二级
			secondCategroySldIdx(value, oldvalue) {
				// debugger;
				// swiper滑动下标值传给nav导航,目的是为了导航的下标和swiper的下标索引能时时同步不存在bug
				this.secondCategroySwToNav = value;
				this.secondCategroySldIdx = value;
			},
			secondCategroySwToNav(value, oldValue) {
				// debugger;
				// 点击导航发送给swiper的值,目的是为了导航的下标和swiper的下标索引能时时同步不存在bug
				this.secondCategroySldIdx = value;
				this.secondCategroySwToNav = value;
			},
			//言情 二级
			secondCategroySldIdx02(value, oldvalue) {
				this.secondCategroySwToNav02 = value;
				this.secondCategroySldIdx02 = value;
			},
			secondCategroySwToNav02(value, oldValue) {
				this.secondCategroySldIdx02 = value;
				this.secondCategroySwToNav02 = value;
			},
			//纯爱 二级
			secondCategroySldIdx03(value, oldvalue) {
				this.secondCategroySwToNav03 = value;
				this.secondCategroySldIdx03 = value;
			},
			secondCategroySwToNav03(value, oldValue) {
				this.secondCategroySldIdx03 = value;
				this.secondCategroySwToNav03 = value;
			},
			
			//衍生 二级
			secondCategroySldIdx04(value, oldvalue) {
				// debugger;
				this.secondCategroySwToNav04 = value;
				this.secondCategroySldIdx04 = value;
			},
			secondCategroySwToNav04(value, oldValue) {
				this.secondCategroySldIdx04 = value;
				this.secondCategroySwToNav04 = value;
			},
		},
		methods: {
			onRefresh() {
				setTimeout(() => {
					// Toast('已获取到最新数据');
					this.bookcityIndexDataFn();
					this.isLoading = false;
				}, 1000);
			},
			bookcityIndexDataFn() {
				this.bookcityBox_show = true;
				// this.$axios.post(this.$api.bookcityIndex).then((response) => {
				// 	if (response.data.code == 1) {
				// 		this.bookcityBox_show = true;
						// // 公告栏
						// this.homeListData.rotation_msg = response.data.data.rotation_msg;
						// //banner轮播
						// this.homeListData.banner_list = response.data.data.banner_list;
						// //云锦金榜
						// this.homeListData.yjjb_list = response.data.data.yjjb_list;
						// //首页强推
						// this.homeListData.syqt_list = response.data.data.syqt_list;
						// //言情完结精品
						// this.homeListData.yqwjjp_list = response.data.data.yqwjjp_list;
						// //衍生完结精品
						// this.homeListData.yswjjp_list = response.data.data.yswjjp_list;
						// //VIP完结精品
						// this.homeListData.vxwzb_list = response.data.data.vxwzb_list;
						// //最近更新
						// this.homeListData.new_list = response.data.data.new_list;
						// //热门导航
						// this.homeListData.label = response.data.data.label;
						// //黑马榜
						// this.homeListData.dark_horse_list = response.data.data.dark_horse_list
						// //纯爱完结精品
						// this.homeListData.cawjjp_list = response.data.data.cawjjp_list
				// 	} else {
				// 		Toast(response.data.msg);
				// 	}
				// })
			},
			handleScroll() {
				this.height_scroll = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
				// console.log(this.height_scroll,'height_scroll')
			},


			// 点击导航菜单通过emit传给父亲然后父亲再传给子组件swiper组件
			firstValueTab(data) {
				this.slideIndex = data;
				localStorage.setItem('navInde',this.slideIndex)
				this.secondCategroySldIdx = null;//分类导航
				this.secondCategroySwToNav = null;//分类导航
				this.secondCategroySldIdx02 = null;//言情导航
				this.secondCategroySwToNav02 = null;//言情导航
				this.secondCategroySldIdx03 = null;//言情导航
				this.secondCategroySwToNav03 = null;//言情导航
				this.secondCategroySldIdx04 = null;//言情导航
				this.secondCategroySwToNav04 = null;//言情导航
				this.$store.commit('saveNavIndex', this.slideIndex)
			},
			// swiper滑动后下标通过emit传给父亲。父亲再传给子组件nav
			slideSendNav(index) {
				console.log('swiper传的下标', index)
				window.scrollTo(0,0); //当滚动条不在顶部时，左右滑动页面，将滚动条置顶
				this.swiperToNav = index;
				localStorage.setItem('swpierIndex',this.swiperToNav)
				this.secondCategroySwToNav = null;//分类导航
				this.secondCategroySwToNav02 = null;//言情导航
				this.secondCategroySwToNav03 = null;//言情导航
				this.secondCategroySwToNav04 = null;//言情导航
				this.$store.commit('saveSwiperIndex', this.swiperToNav)
			},

			// 二级导航 -- 分类
			getFirCateValue(data) { //点击
				this.slideIndex = 0;
				this.secondCategroySldIdx = data;
				this.secondCategroySwToNav = data;
				localStorage.setItem('navInde',this.slideIndex)
				localStorage.setItem('secondCategroy',data)
				this.$store.commit('saveSecondCategroy', data)
			},
			firstCateSlideSendNav(index) {
				console.log('swiper传的下标', index)
				window.scrollTo(0,0); //当滚动条不在顶部时，左右滑动页面，将滚动条置顶
				this.swiperToNav = 0;
				localStorage.setItem('swpierIndex',this.swiperToNav)
				this.secondCategroySwToNav = index;
				this.secondCategroySldIdx = index;
				localStorage.setItem('swipersecondCategroy',index)
				this.$store.commit('saveSwipersecondCategroy', index)
			},
			// 言情 -- 二级
			getFirCateValue02(data) {
				this.slideIndex = 1;
				localStorage.setItem('navInde',this.slideIndex)
				this.secondCategroySldIdx02 = data;
				this.secondCategroySwToNav02 = data;
				localStorage.setItem('secondCategroy02',data)
				this.$store.commit('saveSecondCategroy02', data)
			},
			firstCateSlideSendNav02(index) {
				console.log('swiper传的下标', index)
				window.scrollTo(0,1); //当滚动条不在顶部时，左右滑动页面，将滚动条置顶
				this.swiperToNav = 1;
				localStorage.setItem('swpierIndex',this.swiperToNav)
				this.secondCategroySwToNav02 = index;
				this.secondCategroySldIdx02 = index;
				localStorage.setItem('swipersecondCategroy02',index)
				this.$store.commit('saveSwipersecondCategroy02', index)
			},
			//纯爱 -- 二级
			getFirCateValue03(data) {
				this.slideIndex = 2;
				localStorage.setItem('navInde',this.slideIndex)
				this.secondCategroySldIdx03 = data;
				this.secondCategroySwToNav03 = data;
				localStorage.setItem('secondCategroy03',data)
				this.$store.commit('saveSecondCategroy03', data)
			},
			firstCateSlideSendNav03(index) {
				console.log('swiper传的下标', index)
				window.scrollTo(0,2); //当滚动条不在顶部时，左右滑动页面，将滚动条置顶
				this.swiperToNav = 2;
				localStorage.setItem('swpierIndex',this.swiperToNav)
				this.secondCategroySwToNav03 = index;
				this.secondCategroySldIdx03 = index;
				localStorage.setItem('swipersecondCategroy03',index)
				this.$store.commit('saveSwipersecondCategroy03', index)
			},
			//衍生 -- 二级
			getFirCateValue04(data) {
				this.slideIndex = 3;
				localStorage.setItem('navInde',this.slideIndex)
				this.secondCategroySldIdx04 = data;
				this.secondCategroySwToNav04 = data;
				localStorage.setItem('secondCategroy04',data)
				this.$store.commit('saveSecondCategroy04', data)
			},
			firstCateSlideSendNav04(index) {
				console.log('swiper传的下标', index)
				window.scrollTo(0,3); //当滚动条不在顶部时，左右滑动页面，将滚动条置顶
				this.swiperToNav = 3;
				localStorage.setItem('swpierIndex',this.swiperToNav)
				this.secondCategroySwToNav04 = index;
				this.secondCategroySldIdx04 = index;
				localStorage.setItem('swipersecondCategroy04',index)
				this.$store.commit('saveSwipersecondCategroy04', index)
			},
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll);
			this.swiperToNav = this.$store.state.navInde;  
			this.slideIndex = this.$store.state.swpierIndex;
			
			this.secondCategroySldIdx = this.$store.state.secondCategroy; //二级点击
			this.secondCategroySwToNav = this.$store.state.swipersecondCategroy; //二级滑动
			
			this.secondCategroySldIdx02 = this.$store.state.secondCategroy02; //二级点击
			this.secondCategroySwToNav02 = this.$store.state.swipersecondCategroy02; //二级滑动
			
			this.secondCategroySldIdx03 = this.$store.state.secondCategroy03; //二级点击
			this.secondCategroySwToNav03 = this.$store.state.swipersecondCategroy03; //二级滑动
			
			this.secondCategroySldIdx04 = this.$store.state.secondCategroy04; //二级点击
			this.secondCategroySwToNav04 = this.$store.state.swipersecondCategroy04; //二级滑动
		},
		destroyed() {
			window.removeEventListener('scroll', this.handleScroll) //  离开页面清除（移除）滚轮滚动事件
		}
	}
</script>
<style scoped="scoped" lang="less">
	.bgcwhite {
		height: 70px;
		background-color: #fff !important;
		border-bottom: 1px solid #f0f0f0;
	}

	.bookcityBox {
		background-color: #fff;
	}
	.van-pull-refresh{
		height: calc(100vh - 160px);
		overflow: hidden;
	}
	
	.bookcity_box{
		height: calc(100vh - 160px);
		overflow: hidden;
	}
</style>
